import {Component, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {IsGranted} from '../../../../../decorator/is-granted';
import {MetaTitle} from '../../../../../decorator/meta-title';
import {FormControl, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import {BotRule} from '../../../../../models/bot-rule';
import {LoaderService} from '../../../../../services/loader/loader.service';
import {SnackbarService} from '../../../../../services/snackbar/snackbar.service';
import {BotRuleService} from '../../../../../services/bot-rule/bot-rule.service';

import {ActivatedRoute, Router, RouterLink} from '@angular/router';
import {AuthService} from '../../../../../services/auth/auth.service';
import {InputSwitchComponent} from '../../../../layout/input-switch/input-switch.component';

@Component({
  selector: 'app-bot-rule-form',
  imports: [
    ReactiveFormsModule,
    RouterLink,
    InputSwitchComponent
],
  templateUrl: './bot-rule-form.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './bot-rule-form.component.scss'
})
@IsGranted(['BOT_RULE_VIEW', 'ROLE_API_BOT_RULE_WRITE'])
@MetaTitle('Bot rules')
export class BotRuleFormComponent implements OnInit {
  botRule: BotRule | null = null;

  form = new FormGroup({
    name: new FormControl('', Validators.required),
    rule: new FormControl('', Validators.required),
    allowed: new FormControl(false),
    position: new FormControl(0),
  });

  constructor(
    private loader: LoaderService,
    private snackbar: SnackbarService,
    private route: ActivatedRoute,
    private router: Router,
    private auth: AuthService,
    private botRuleService: BotRuleService,
  ) {
  }

  ngOnInit(): void {
    this.loader.startLoading();

    const id = Number(this.route.snapshot.paramMap.get('id'));

    if (id) {
      this.botRuleService.findOneById(id).subscribe((botRule: BotRule) => {
        this.botRule = botRule;

        this.form.patchValue({
          name: botRule.name,
          rule: botRule.rule,
          allowed: botRule.allowed,
          position: botRule.position
        });

        this.loader.stopLoading();
      });
    } else {
      this.loader.stopLoading();
    }
  }

  isCreate(): boolean {
    return !this.botRule;
  }

  canUpdate(): boolean {
    return this.auth.hasRolesSync(['ROLE_API_BOT_RULE_WRITE']);
  }

  onSubmit(): void {
    if (!this.form.valid) {
      return;
    }

    this.loader.startLoading();

    let params: any = this.form.value;

    if (this.isCreate()) {
      this.botRuleService.create(params).subscribe(() => {
        this.loader.stopLoading();
        this.snackbar.success('Rule has been created.');
        this.router.navigateByUrl('/translation/bot-rules').then();
      });
    } else if (this.botRule?.id) {
      this.botRuleService.update(this.botRule.id, params).subscribe(() => {
        this.loader.stopLoading();
        this.snackbar.success('Rule has been modified.');
        this.router.navigateByUrl('/translation/bot-rules').then();
      });
    }
  }
}
